import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TenantService } from '../tenant/tenant.service';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { delay, finalize, retryWhen, take, tap } from 'rxjs/operators';
import { Logger, LoggingService } from 'ionic-logging-service';

@Injectable({
  providedIn: 'root'
})
export class PasswordService { // for AirPrint

  private httpErrorResponse: HttpErrorResponse;
  private logger: Logger;
  public tenant = this.tenantService.tenantSignal;

  constructor(
    private device: Device,
    private httpClient: HttpClient,
    private loggingService: LoggingService,
    private tenantService: TenantService
    ) {
      this.logger = this.loggingService.getLogger("[PasswordService]");
      const methodName = "ctor";
      this.logger.entry(methodName);
    }

  public generateAirPrintPassword(): Observable<any> {
    this.logger.info('generateAirPrintPassword()');
    const generatePasswordUrl: string = this.tenant().links.airPrintPasswords;
    const deviceUuid = this.device.uuid;
    return new Observable((observer) => {
      this.httpClient.post<any>(generatePasswordUrl, {deviceIdentifier: deviceUuid})
      .pipe(retryWhen(error => error.pipe(
        delay(1000),
        take(1),
        tap((httpErrorResponse: HttpErrorResponse) => {this.httpErrorResponse = httpErrorResponse}),
        finalize(() => {
          observer.error(this.httpErrorResponse);
          observer.complete();
        })
      )))
      .subscribe((response: any) => {
        observer.next(response);
        observer.complete();
      });
    });
  }
}